import styled from 'styled-components';
import { color } from 'styles/colors';

export const container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
`;

export const itemImg: any = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  > img {
    width: 100%;
    height: 100%;
    object-fit: fill;
  }

  > p {
    font-weight: 900;
    font-size: 0.8rem;
    color: ${color.interface.darkgray};
    text-align: center;
  }
`;
